import { parse } from '@/services/languageParser'

const DEFAULT_LANGUAGE = 'en-GB'
const SUPPORTED_LANGUAGES = [
    'en-GB',
    'en-US',
    'en-CA',
    'da-DK',
    'de-DE',
    'el-GR',
    'es-ES',
    'fi-FI',
    'hr-HR',
    'nb-NO',
    'nl-NL',
    'sv-SE',
    'fr-FR'
]

const LANGUAGE_BY_REGION = {
    GB: 'en-GB',
    US: 'en-US',
    CA: 'en-CA',
    DK: 'da-DK',
    DE: 'de-DE',
    GR: 'el-GR',
    ES: 'es-ES',
    FI: 'fi-FI',
    HR: 'hr-HR',
    NO: 'nb-NO',
    NL: 'nl-NL',
    SE: 'sv-SE',
    FR: 'fr-FR'
}

const LANGUAGE_BY_CODE = {
    en: 'en-GB',
    da: 'da-DK',
    de: 'de-DE',
    el: 'el-GR',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hr: 'hr-HR',
    nb: 'nb-NO',
    nl: 'nl-NL',
    no: 'nb-NO',
    sv: 'sv-SE'
}

export default {
    methods: {
        normalizeLanguage(language) {
            if (!language || typeof language !== 'string') {
                return null
            }

            const formattedLanguage = language.replace(/_/g, '-').trim().toLowerCase()

            return (
                SUPPORTED_LANGUAGES.find(
                    supportedLanguage => supportedLanguage.toLowerCase() === formattedLanguage
                ) || null
            )
        },
        getUrlLanguage(language) {
            const normalizedLanguage = this.normalizeLanguage(language) || DEFAULT_LANGUAGE

            return normalizedLanguage.toLowerCase()
        },
        resolveLanguage(language) {
            const normalizedLanguage = this.normalizeLanguage(language)

            if (normalizedLanguage) {
                return normalizedLanguage
            }

            if (!language) {
                return DEFAULT_LANGUAGE
            }

            const languages = parse(language)
            const region = languages && languages[0] ? languages[0].region : null
            const code = languages && languages[0] ? languages[0].code : null

            return LANGUAGE_BY_REGION[region] || LANGUAGE_BY_CODE[code] || DEFAULT_LANGUAGE
        },
        syncLanguageToRoute(language, replaceHistory = true) {
            if (!this.$router || !this.$route) {
                return
            }

            const urlLanguage = this.getUrlLanguage(language)

            if (this.$route.query.lang === urlLanguage) {
                return
            }

            const navigationMethod = replaceHistory ? 'replace' : 'push'

            this.$router[navigationMethod](
                {
                    path: this.$route.path,
                    query: Object.assign({}, this.$route.query, { lang: urlLanguage })
                },
                () => {},
                () => {}
            )
        },
        applyLanguage(language, options = {}) {
            const settings = Object.assign(
                {
                    updateUrl: false,
                    replaceHistory: true
                },
                options
            )
            const resolvedLanguage = this.resolveLanguage(language)

            this.setCurrentLanguage(resolvedLanguage)
            this.setTranslation(this.$content[resolvedLanguage] || this.$content[DEFAULT_LANGUAGE])

            if (settings.updateUrl) {
                this.syncLanguageToRoute(resolvedLanguage, settings.replaceHistory)
            }

            return resolvedLanguage
        },
        setLanguage(language, options = {}) {
            return this.applyLanguage(language, options)
        }
    }
}
